module.exports = __webpack_public_path__ + "img/mecklenburg-vorpommern.6a1d62f.webp";